import React from 'react';
import { Container } from 'react-bootstrap';
import Layout from '../layout';
import ReportsGallery from './components/ReportsGallery';

const ReportsPage = () => (
  <Layout>
    <Container fluid className="py-4 h-100 d-flex flex-column flex-fill">
      <ReportsGallery />
    </Container>
  </Layout>
);

export default ReportsPage;
